export const pricing = {
  methods: {
    priceItem (spotPriceData, itemData) {
      var itemBid = null
      var itemAsk = null

      // CHECK REQUIRED DATA FOR PRICE CALCULATION
      var dataCheck = true

      const weigthOz = parseFloat(itemData.WC_OZWT)
      const bidPremium = parseFloat(itemData.premium_bid)
      const askPremium = parseFloat(itemData.premium_ask)

      if (typeof weigthOz === 'undefined' || weigthOz == null) {
        console.log('MISSING WEIGHT')
        dataCheck = false
      }
      if (typeof bidPremium === 'undefined' || bidPremium == null) {
        console.log('MISSING BID PREMIUM')
        dataCheck = false
      }
      if (typeof askPremium === 'undefined' || askPremium == null) {
        console.log('MISSING ASK PREMIUM')
        dataCheck = false
      }

      if (typeof itemData.use_percent === 'undefined' || itemData.use_percent == null) {
        console.log('MISSING PERCENT FLAG')
        dataCheck = false
      }
      if (typeof itemData.melt_plus === 'undefined' || itemData.melt_plus == null) {
        console.log('MISSING MELT FLAG')
        dataCheck = false
      }
      if (typeof itemData.pricing_type === 'undefined' || itemData.pricing_type == null) {
        console.log('MISSING PRICING TYPE')
        dataCheck = false
      }

      const pricingType = itemData.pricing_type

      if (spotPriceData) {
        const currentSpotPrice = spotPriceData[pricingType]

        if (currentSpotPrice) {
          if (typeof currentSpotPrice.bid === 'undefined' || currentSpotPrice.bid == null) {
            console.log('MISSING SPOT BID')
            dataCheck = false
          }
          if (typeof currentSpotPrice.ask === 'undefined' || currentSpotPrice.ask == null) {
            console.log('MISSING SPOT ASK')
            dataCheck = false
          }
        } else {
          if (pricingType !== 'FIX') {
            console.log('MISSING SPOT PRICE DATA')
            dataCheck = false
          }
        }

        // CALCULATE PRICE
        if (dataCheck) {
          if (pricingType === 'FIX') { // FIXED
            itemBid = bidPremium
            itemAsk = askPremium
          } else {
            if (currentSpotPrice) {
              if (itemData.use_percent) { // PERCENTAGE
                itemBid = currentSpotPrice.bid * weigthOz * bidPremium
                itemAsk = currentSpotPrice.ask * weigthOz * askPremium
                // var bidPer = (bidPremium + '').split('.')[1]
                // bidPer = bidPer.length === 1 ? bidPer + '0' : bidPer
                // var calculatePerBid = parseInt(bidPer) / 100 * bidPremium
                // itemBid = currentSpotPrice.bid * weigthOz * calculatePerBid
                // var askPer = (askPremium + '').split('.')[1]
                // askPer = askPer.length === 1 ? askPer + '0' : askPer
                // var calculatePerAsk = parseInt(askPer) / 100 * askPremium
                // itemAsk = currentSpotPrice.ask * weigthOz * calculatePerAsk
              } else {
                if (itemData.melt_plus) { // MELT PLUS
                  itemBid = currentSpotPrice.bid * weigthOz + bidPremium
                  itemAsk = currentSpotPrice.ask * weigthOz + askPremium
                } else { // STANDARD
                  itemBid = (currentSpotPrice.bid + bidPremium) * weigthOz
                  itemAsk = (currentSpotPrice.ask + askPremium) * weigthOz
                }
              }
            }
          }
        } else {
          console.log('PRICING DATA CHECK FAILED')
          console.log(itemData)
          console.log(currentSpotPrice)
        }

        // ROUNDING
        if (itemBid && itemAsk) {
          const rnd = (itemData.rounding ? parseFloat(itemData.rounding) : 0.01)
          itemBid = Math.round(itemBid / rnd) * rnd
          itemAsk = Math.ceil(itemAsk / rnd) * rnd
        }
      } else {
        console.log('MISSING SPOT PRICE DATA')
        dataCheck = false
      }

      return {
        bid: itemBid,
        ask: itemAsk
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/pricing.js